import { Grid } from '@mui/material';
import { WithStyles } from '@mui/styles';
import createStyles from '@mui/styles/createStyles';
import withStyles from '@mui/styles/withStyles';
import { Theme } from '~/themes';
import { FastField, Field } from '~/components/common/Formik';
import UserInfoIcon from '~/assets/images/icons/user-info.svg';

const style = (theme: Theme) =>
  createStyles({
    transitTitle: {
      display: 'flex',
      fontWeight: 600,
      alignItems: 'center',
    },
    transitLogo: {
      'display': 'flex',
      'alignItems': 'center',
      'justifyContent': 'center',
      'width': 25,
      'height': 25,
      'borderRadius': 5,
      'backgroundColor': theme.bg.darkPurple,
      'marginRight': theme.spacing(1),
      '& img': {
        width: 19,
      },
      '&.store': {
        backgroundColor: theme.bg.primaryOrange,
      },
      '&.warehouse': {
        backgroundColor: theme.bg.breadstack,
      },
    },
  });

interface IProps extends WithStyles<typeof style> {}

const InviteDriverForm: React.FC<IProps> = ({ classes }) => (
  <>
    <div className={classes.transitTitle}>
      <span className={classes.transitLogo}>
        <img src={UserInfoIcon} alt='user-info' />
      </span>
      Driver Info
    </div>
    <Grid container rowSpacing={2} columnSpacing={3}>
      <Grid item xs={12} md={6} key='first_name'>
        <FastField.TextInput name='first_name' legend='First Name' />
      </Grid>
      <Grid item xs={12} md={6} key='last_name'>
        <FastField.TextInput name='last_name' legend='Last Name' />
      </Grid>
      <Grid item xs={12} md={6} key='display_name'>
        <FastField.TextInput
          name='display_name'
          legend='Display Name (Optional)'
        />
      </Grid>
      <Grid item xs={12} md={6} key='phone'>
        <Field.TextInput
          legend='Phone Number'
          name='phone'
          type='tel'
          prefix={<FastField.CountryCodeDropdown name='country_code' />}
        />
      </Grid>
    </Grid>
  </>
);

export default withStyles(style)(InviteDriverForm);
